import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingHRForm(props) {
  return <SpaceRoleRangeForm {...props} role="hr" settingKey="hr_role_setting" />;
}

export default SpacesSettingHRForm;
